<template>
  <div class="mt-2 flex items-center gap-4">
    <ChatLauncher v-if="themeConfig && themeConfig.launcher"
                  :lang-config="langConfig"
                  :theme-config="themeConfig"
                  class="mb-0 cursor-default"
                  :button-icon-cache="buttonIcon"
    />

    <base-file-input variant="bordered"
                     class="whitespace-nowrap p-0 w-5/6"
                     v-model="buttonIcon"
    >
      Change
    </base-file-input>
  </div>
</template>

<script>
import ChatLauncher from '@/components/settings/bot-theme/chat-widget/components/chat/ChatLauncher.vue'
import BaseButton from '@/components/base-components/BaseButton.vue'
import BaseFileInput from '@/components/base-components/BaseFileInput.vue'

export default {
  name: 'SettingsBotThemeLauncherIcon',
  components: { BaseFileInput, BaseButton, ChatLauncher },

  props: {
    themeConfig: {
      type: Object,
      default: () => {}
    },
    langConfig: {
      type: Object,
      default: () => {}
    },
    value: {
      type: File | String
    }
  },

  computed: {
    buttonIcon: {
      get() {
        return this.value
      },
      set(file) {
        this.$emit('input', file)
      }
    }
  }
}
</script>
